import axios from 'axios';

export const sendData = params => axios.post('/b/stats', {
  step: params
});

export const getPaginateCounts = (params) => axios.get(`/b/stats/list?limit=${params.limit}&offset=${params.page}`);